var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "mb-2 col-md-" + _vm.colSize },
    [
      _c(_vm.isTextarea ? "v-textarea" : "v-text-field", {
        tag: "v-text-field",
        attrs: {
          label: _vm.label,
          placeholder: _vm.label,
          filled: _vm.disabled,
          outlined: !_vm.disabled,
          dense: "",
          "hide-details": "auto",
          disabled: _vm.disabled,
          maxlength: _vm.maxlength,
          rules: _vm.rules,
          "auto-grow": _vm.autoGrow,
          rows: _vm.rows,
        },
        on: { keypress: _vm.onKeyPress },
        model: {
          value: _vm.internalValue,
          callback: function ($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }